import { LoginContext } from "../Components/LoginProvider";
import { useContext } from "react";

const useLogin = () => {
  return useContext(LoginContext);
}

export default useLogin;